import { Vector2 } from 'three';

export const pathTo3D = (path: Vector2[]): [number, number, number][] => path.map((point) => [point.x, point.y, 0]);
